import React, { useState }  from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

//styles
import { Navbar, Nav } from 'react-bootstrap';

//components
import Products from './Products';
import About from './About';
import Cart from './Cart';

const Main = () => {
    const [item, setItem] = useState([]);

//pridejimas i krepseli
const addToCart = (product) => {
        console.log(product)
        let newCart = [...item]; 

        let arYra = newCart.find(
           (preke) => product.name === preke.name)

          console.log(arYra );

        if(arYra && arYra.kiekis < product.countInStock){
            console.log('pirmas if kai jau yra')
            arYra.kiekis++;
        } 
        else if(arYra===undefined && product.countInStock>0){
            arYra = {
                ...product,
                kiekis :1
            }
            newCart.push(arYra)
            console.log("else if kai tokiu pavadinimu nera")
        } else {
            alert("Prekes nebera sandelyje");
        }
        setItem(newCart);          
    } 
    //console.log(item);

    //viso krepselio isvalymas
const clearCart = () => {
        console.log("trynimas viso krepselio");
        setItem([]);
    }

    //konkrecios prekes kiekio mazinimas
    const decreaseQuantity = (product) => {
        //console.log(`prekes mazinimo funkcionalumas ${product}`);
        let newCart = [...item]; 
        let arYra = newCart.find(
           (preke) => product.name === preke.name);
           if(arYra.kiekis > 1){
               arYra.kiekis--;
               setItem(newCart.splice(arYra))
               
           } else {
               setItem(item.filter((product) => product !== arYra))              
           }
    }
//konkrecios prekes kiekio padidinimas
    const increaseQuantity = (product) =>{
        let newCart = [...item]; 
        let arYra = newCart.find(
           (preke) => product.name === preke.name);

        if(arYra && arYra.kiekis<product.countInStock){
            arYra.kiekis++;
        } else {
            alert(`Prekės likutis, deja tik  ${product.countInStock}`)
        }
        setItem(newCart)
    }
       
    //konkrecios prekes istrynimas
    const deleteProduct = (product) =>{        
        setItem(item.filter((p) => p !== product));
    }

    return (
       
            <Router>  
            <Navbar bg="light" variant="light" className="sticky-top">
                <Link to="/"><Navbar.Brand >Apsipirk</Navbar.Brand></Link>
                <Nav className="mr-auto">
                    <Nav.Link><Link to="/items">Parduotuve</Link></Nav.Link>           
                    <Nav.Link><i className="fas fa-shopping-cart"></i><Link to="/cart" className="ml-2">Krepselis</Link></Nav.Link>         
                </Nav>   
            </Navbar>
                      
                <Switch>
                    <Route path="/" exact component={About}/>
                    <Route path="/items" exact >
                        <Products addToCart={addToCart}/>
                    </Route>      
                    <Route path="/cart">
                        <Cart item={item} clearCart={clearCart} decreaseQuantity={decreaseQuantity} deleteProduct={deleteProduct} increaseQuantity={increaseQuantity}/>
                    </Route>
                    
                </Switch>
            </Router>
      
    )
}

export default Main
